import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';


// Async Thunk
   export const changePartnerStatus = createAsyncThunk(
  'partner/changeStatus',
   async ({ member_id, is_active, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        'https://onboard.rechargkit.biz/member/changePartnerStatus',
        { member_id, is_active },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Something went wrong');
    }
  }
);

// Slice
const changePartnerStatusSlice = createSlice({
  name: 'partnerStatus',
  initialState: {
    loading: false,
    success: false,
    error: null,
    message: '',
  },
    reducers: {
    resetPartnerStatus(state) {
      state.loading = false;
      state.success = false;
      state.error = null;
      state.message = '';
    },
  },
    extraReducers: (builder) => {
    builder
      .addCase(changePartnerStatus.pending, (state) => {
        state.loading = true;
        state.success = false;
        state.error = null;
        state.message = '';
      })
      .addCase(changePartnerStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.error === 0;
        state.message = action.payload.msg;
      })
      .addCase(changePartnerStatus.rejected, (state, action) => {
        state.loading = false;
        state.success = false;
        state.error = action.payload;
      });
  },
});

export const { resetPartnerStatus } = changePartnerStatusSlice.actions;
export default changePartnerStatusSlice.reducer;
